import styled from 'styled-components'
import { MenuIconWrapper } from '../MenuIcon/MenuIconStyled'

export const LandingHeaderWrapper = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  background: linear-gradient(90deg, #214081 0%, #23B04E 100%);
  z-index: 2;
  padding: 6px 0;
`

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 8px 0;
  @media only screen and (max-width: 768px) {
    gap: 8px;
  }
`
export const HeaderMenu = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  gap: 24px;
  @media only screen and (max-width: 767px) {
    gap: 8px;
    justify-content: end;
    flex-wrap: wrap;
    padding: 4px;
  }
`

export const HeaderMenuItem = styled.li`
    text-transform: capitalize;
    color: #ffffff;
    list-style-type: none;
    text-decoration: none;
    font-size: 15px;
    display: flex;
    align-items: end;
    cursor: pointer;
    //@media only screen and (max-width: 767px) {
    //  width: calc(50% - 16px);
    //  &:nth-child(even) {
    //    justify-content: end;
    //  }
    //}

    @media only screen and (max-width: 767px) {
        margin-bottom: 8px;
        a {
            color: #ffffff;
        }
    }

    &:active {
        ${MenuIconWrapper} {
            .circle {
                opacity: 1;
            }

            .circle:before {
                opacity: 1;
            }

            .circle:after {
                opacity: 1;
            }

            .outer-circle1 {
                opacity: 1;
            }

            .outer-circle2 {
                opacity: 1;
            }
        }
    }

    &:hover {
        a:before, a:after {
            opacity: 1; /* Hiển thị pseudo-element */
        }
    }

    a {
        min-width: 128px;
        padding: 0 16px 4px 8px;
        font-weight: 600;
        position: relative;
        border-bottom: 1px solid #fff;
        @media only screen and (max-width: 1200px) {
            font-size: 12px;
            min-width: 0;
        }
        @media only screen and (max-width: 768px) {
            font-size: 11px;
        }
        @media only screen and (max-width: 767px) {
            font-size: 11px;
            min-width: 125px;
        }


        &:before {
            content: "";
            position: absolute;
            bottom: -4px;
            left: 0;
            width: 100%;
            border-radius: 50%;
            height: 7px;
            background-image: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.7), transparent);
            background-size: 100% 10px;
            background-position: center center;
            background-repeat: no-repeat;
            transition: opacity 0.5s ease; /* Hiệu ứng chậm trong 1s */
            opacity: 0;
        }

        &:after {
            content: "";
            position: absolute;
            bottom: -3px;
            left: 0;
            width: 100%;
            border-radius: 50%;
            height: 5px;
            background-image: linear-gradient(to right, transparent, rgb(255, 255, 255, 0.8), transparent);
            background-size: 100% 10px;
            background-position: center center;
            background-repeat: no-repeat;
            transition: opacity 0.5s ease; /* Hiệu ứng chậm trong 1s */
            opacity: 0;
        }

    }
`
export const MainLogo = styled.img`
  @media only screen and (max-width: 1200px) {
    height: 24px;
  }
  @media only screen and (max-width: 768px) {
  }
  @media only screen and (max-width: 767px) {

  }
`
export const IconShine = styled.div`

`